import { Component, Inject, OnInit } from '@angular/core';

import { CreditService } from '@my-account/data-access/services';
import { MyAccountErrorLogKeys } from '@shared/data-access/enums';
import { MyAccountAnalyticsService } from '@shared/data-access/services';
import { WINDOW } from '@shared/utils/services';
import { take } from 'rxjs/operators';

@Component({
	selector: 'my-account-templates-ezapply-credit-card',
	templateUrl: './ezapply-credit-card.component.html',
	styleUrls: []
})
export class EzApplyCreditCardComponent implements OnInit {
	public hasError = false;

	constructor(
		private analyticsService: MyAccountAnalyticsService,
		private creditService: CreditService,
		@Inject(WINDOW) protected window: Window,
	) {}

	ngOnInit(): void {
		this.creditService.getCreditApplyUri()
			.pipe(take(1))
			.subscribe({
				next: (creditResponse) => {
					let redirectUrl = '';
					redirectUrl = creditResponse.creditApplyUrl.toString();
					if (redirectUrl !== '') {
						this.analyticsService.setEventType('EZApplyCreditCard');
						this.analyticsService.triggerAnalyticsEvent('EZApplyCreditCard');
						this.window.location.href = redirectUrl;
					} else {
						this.hasError = true;
						this.analyticsService.generateLogError(MyAccountErrorLogKeys.EZ_APPLY_CREDIT_CARD, 'Error getting credit apply URL');
					}
				},
				error: (err) => {
					this.hasError = true;
					this.analyticsService.generateLogError(MyAccountErrorLogKeys.EZ_APPLY_CREDIT_CARD, 'Error getting credit apply URL', err);
				}
			});
	}
}
